import { Dropdown } from 'antd';
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import MultiSelectOverlay from '../MultiSelectOverlay';
import { DropdownLabel } from '../styled/form';
import { RotateIcon } from '../styled/icon';
const ClosedText = styled.span `
  text-align: left;
`;
// Designed to work with `getFieldDecorator` forms, hence the forwardRef. We
// don't actually use the ref for anything, though it could be handy in a
// future version. For now it's easier to use the `form` object directly.
//
// Note that you could also re-use MultiSelectOverlay in the context of a
// different form by writing your own wrapper instead of using this one. The
// majority of the selection/search logic is in the overlay, while this
// wrapper controls data flow.
export const MultiSelectForm = forwardRef(({ closedLabel, displayName, fieldName, form, onConfirm, onReset, options, showAll, showSearch, shifted, groups, disabled }, _) => {
    const [visible, setVisible] = useState(false);
    const confirm = onConfirm || (() => setVisible(false));
    const reset = onReset || (() => form.resetFields([fieldName]));
    const onSelect = (selectedItems) => {
        const usedGroups = selectedItems.reduce((prev, selected, currentIndex, array) => {
            if (selected.group != '' && !prev.includes(selected.group)) {
                return [selected.group, ...prev];
            }
            return prev;
        }, []);
        const reducedItems = selectedItems
            .filter(e => e.group === '')
            .map(e => e.value);
        const value = [...reducedItems, ...usedGroups];
        form.setFieldsValue({ [fieldName]: value });
    };
    return (React.createElement(Dropdown, { disabled: disabled, onVisibleChange: () => setVisible(!visible), overlay: React.createElement(MultiSelectOverlay, { displayName: displayName || fieldName, onConfirm: confirm, onReset: reset, onSelect: onSelect, options: options, selected: form.getFieldValue(fieldName), showAll: showAll, showSearch: showSearch, shifted: shifted, groups: groups }), trigger: ['click'], visible: visible },
        React.createElement(DropdownLabel, { onClick: e => e.preventDefault(), disabled: disabled },
            React.createElement(ClosedText, null, closedLabel),
            React.createElement(RotateIcon, { type: "down", rotate: visible ? 180 : 0 }))));
});
export default MultiSelectForm;
